import {
	CommonChatMessage,
} from "@/components/molecules/interactionWorkspace";
import { InfiniteQueryFnParams } from "@/hooks/infiniteQuery";
import { mapUrl, Client } from "../client";
import { Endpoint } from "../endpoint";
import { ExtendedPagedResult } from "../pagedResult";
import { Controller } from "../controller";

export const TranscriptionMessagesKey = "TranscriptionMessages";
export const TranscriptionHistoryMessagesKey = "TranscriptionHistoryMessages";
export const TranscriptionLanguagesKey = "TranscriptionLanguages";
export const DEFAULT_TRANSCRIPTION_LANGUAGE = "en-US";

export interface TranscriptionLocale {
	localeCode: string;
	displayName: string;
}

export const fetchTranscriptionLanguages = (): Promise<TranscriptionLocale[]> => {
	return Client.instance.get(Controller.TranscriptionLanguages);
};

export const fetchTranscription = ({
	page: page,
	searchValue,
	sessionId,
}: InfiniteQueryFnParams): Promise<ExtendedPagedResult<CommonChatMessage>> => {
	if (!sessionId) {
		return Promise.reject(new Error("sessionId is required"));
	}

	if (!searchValue) {
		return Promise.reject(new Error("date is required"));
	}

	const query = {
		page,
		pageSize: 20,
		searchValue,
	};

	const url = mapUrl(Controller.MediaVoice, sessionId, Endpoint.Transcription);

	return Client.instance.get(url, query);
};

export const getCallSummary = (conversationId: string, startDate: string | undefined): Promise<string> => {
	const query = {
		startDate,
	};

	const url = mapUrl(Controller.MediaVoice, conversationId, Endpoint.Summary);

	return Client.instance.get(url, query);
};